import React from "react";

function Menu() {
  return (
    <div className="mm-menu">
      <div className="mm-menu__wrapper">
        <a href="https://create.travelhub.moscow/" className="mm-menu__logo">
          Креативная
          <br />
          лаборатория
        </a>
      </div>
    </div>
  );
}

export default Menu;
